var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-list-item',[_c('div',[_vm._v(" Points: ")]),_c('div',[_c('animated-number',{staticClass:"points-counter",attrs:{"value":_vm.userPointsComputed,"continue-from-previous":true,"reset":_vm.pointsResetToken,"duration":800}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }